import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40, ...rest }) => (
  <motion.div
    initial={{ y, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : { y: "110%" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const SectionHead = ({ num, eyebrow, title, light = false }) => (
  <div className="mb-14 sm:mb-20">
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        <span className={`font-mono text-xs font-bold tracking-[0.25em] ${light ? "text-obsidian" : "text-acid"}`}>
          {"//"} {num}
        </span>
        <span className={`h-px flex-1 ${light ? "bg-obsidian/20" : "bg-line"}`} />
        <span className={`font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] ${light ? "text-obsidian/60" : "text-dim"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <MaskLine>
      <h2 className={`font-head text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase leading-[0.95] ${light ? "text-obsidian" : "text-cream"}`}>
        {title}
      </h2>
    </MaskLine>
  </div>
);

export const AcidWord = ({ children }) => <span className="text-acid">{children}</span>;
